










import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import InfoTooltip from '@/components/InfoTooltip.vue'

/*
  A custom checkbox
*/

@Component<Checkbox>({
    components: {InfoTooltip}
})
export default class Checkbox extends Vue {
    @Prop(Function) public click?: (id) => void
    @Prop() public checked?
    @Prop(Boolean) public partial?: boolean
    @Prop(String) public label?: string
    @Prop(String) public value?: string
    @Prop(String) public id?: string
    @Prop(String)
    readonly tooltip?: string

    @Prop({ type: Boolean, required: false, default: false })
    public readonly disabled!: boolean

    public handleClick() {
        if (this.click && !this.disabled) {
            this.click(this.id)
        }
    }
}
